import i18n from "i18next";

import resources from "../translations/common.lang.yaml";
import { Language } from "./types";

type TranslationResource = {
  en: Record<string, string>;
  ja: Record<string, string>;
};

/**
 * Get the user's preferred language from browser settings
 * @returns The preferred language code ('en' or 'ja')
 */
export const getPreferredLanguage = (): Language => {
  try {
    for (const lang of navigator.languages) {
      const base = lang.split("-")[0];
      if (base === "en" || base === "ja") {
        return base;
      }
    }
  } catch (e) {
    console.error("Error detecting preferred language:", e);
  }
  return "en";
};

export const initialLanguage = getPreferredLanguage();

/**
 * Load translations for a specific namespace
 * @param translations - Translation resource object containing 'en' and 'ja' keys
 * @param name - Namespace name for the translations
 */
export const loadTranslations = (
  translations: TranslationResource,
  name: string,
): void => {
  i18n.addResourceBundle("en", name, translations.en);
  i18n.addResourceBundle("ja", name, translations.ja);
};

i18n.init({
  resources,
  fallbackLng: "en",
  lng: initialLanguage,
  debug: true,
});

export default i18n;
